import React from 'react';

export default function useDateAdapter() {
    const dateFormat = (date: Date | string, localization?: string) => {
        const dateToFormat = new Date(date);

        if (!dateToFormat) {
            throw new Error();
        }

        const esDate = new Intl.DateTimeFormat('es-MX', {
            dateStyle: 'medium',
            timeStyle: 'medium'
        }).format(dateToFormat);

        return esDate;

        // const enDate = new Intl.DateTimeFormat(localization).format(dateToFormat);
    };

    return { dateFormat };
}
